import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[var(--jb-navy)] text-[var(--jb-bone)] pt-24 pb-10 relative overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-[var(--jb-bone)]/15">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6 bg-[var(--jb-bone)] p-4 inline-flex w-fit rounded-md">
              <picture>
                <source srcSet="/logo-jll-full.webp" type="image/webp" />
                <img
                  src="/logo-jll-full.png"
                  alt="Jaybliss Logistics"
                  className="h-20 w-auto object-contain"
                  width="448"
                  height="320"
                  loading="lazy"
                  decoding="async"
                />
              </picture>
            </div>
            <p className="serif text-[26px] md:text-[34px] leading-[1.15] italic max-w-[520px]">
              "On time, every time — from a single box or furniture to a full home."
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="mono-cap text-[var(--jb-bone)]/60 mb-5">Explore</div>
            <ul className="space-y-3">
              {["Home", "Services", "Why Us", "Coverage", "Quote", "Contact"].map((l) => (
                <li key={l}>
                  <a href={`#${l.toLowerCase().replace(" ", "-")}`} className="link-underline">
                    {l}
                  </a>
                </li>
              ))}
              <li className="pt-3">
                <Link to="/admin/login" className="mono-cap text-[var(--jb-rust)]" data-testid="footer-admin-link">
                  Admin →
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="mono-cap text-[var(--jb-bone)]/60 mb-5">Contact</div>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-[var(--jb-rust)]" />
                <a href="tel:+447396764997" className="serif text-xl">+44 7396 764997</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-[var(--jb-rust)]" />
                <a href="mailto:info@jayblisslogistics.co.uk" className="link-underline">
                  info@jayblisslogistics.co.uk
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[var(--jb-rust)]" />
                <span>Belfast, Northern Ireland — serving all of the UK</span>
              </li>
            </ul>
            <div className="flex items-center gap-4 mt-8">
              <a href="https://facebook.com/Jayblisslogistic" target="_blank" rel="noreferrer" aria-label="Facebook — Jayblisslogistic" className="w-10 h-10 grid place-items-center border border-[var(--jb-bone)]/25 hover:border-[var(--jb-rust)] hover:text-[var(--jb-rust)] transition-colors" data-testid="social-facebook">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://instagram.com/d_vanmanservices" target="_blank" rel="noreferrer" aria-label="Instagram — d_vanmanservices" className="w-10 h-10 grid place-items-center border border-[var(--jb-bone)]/25 hover:border-[var(--jb-rust)] hover:text-[var(--jb-rust)] transition-colors" data-testid="social-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://tiktok.com/@d_vanmanservices" target="_blank" rel="noreferrer" aria-label="TikTok — d_vanmanservices" className="w-10 h-10 grid place-items-center border border-[var(--jb-bone)]/25 hover:border-[var(--jb-rust)] hover:text-[var(--jb-rust)] transition-colors font-semibold text-xs" data-testid="social-tiktok">
                TT
              </a>
            </div>
            <div className="mt-4 mono-cap text-[10px] text-[var(--jb-bone)]/50 space-y-1">
              <div>Facebook · @Jayblisslogistic</div>
              <div>Instagram · @d_vanmanservices</div>
              <div>TikTok · @d_vanmanservices</div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-[var(--jb-bone)]/60">
          <div>© {new Date().getFullYear()} Jaybliss Logistics. Fully insured, Belfast-based. All rights reserved.</div>
          <div className="mono-cap">www.jayblisslogistics.co.uk</div>
        </div>
      </div>
    </footer>
  );
}
